module.exports = __webpack_public_path__ + "assets/img/SRG-Finance-Pillar-Page-Resource-w720.a19489c6.jpg";